module.exports = __webpack_public_path__ + "media/svg-new/avatar-13 2-e5c197ee.svg";